import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "rounded" }
const _hoisted_2 = { class: "d-flex gap-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = ["fill"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = ["fill"]
const _hoisted_11 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_12 = { "clip-path": "url(#clip0_4920_1611)" }
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["fill"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4920_1611" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "18",
      height: "18",
      fill: "white"
    })
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "pontilhado" }, null, -1)
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { style: {"overflow":"hidden"} }
const _hoisted_19 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleOpen && $setup.toggleOpen(...args))),
      style: {"cursor":"pointer","border-bottom":"1px solid #e8e8e8","padding-bottom":"7px"},
      class: "d-flex flex-row gap-3 align-items-center mb-3 justify-content-between"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!$props.disableArrow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              ($setup.isOpen)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                    _createElementVNode("path", {
                      d: "M9.33683 14.9014L1.7453 7.30982C1.37917 6.94368 1.37917 6.35009 1.7453 5.98399L2.63073 5.09857C2.99624 4.73306 3.58862 4.73235 3.95499 5.097L9.99976 11.1134L16.0445 5.097C16.4108 4.73235 17.0032 4.73306 17.3687 5.09857L18.2542 5.98399C18.6203 6.35013 18.6203 6.94372 18.2542 7.30982L10.6627 14.9014C10.2966 15.2675 9.70296 15.2675 9.33683 14.9014Z",
                      fill: $props.arrowColor || '#000000'
                    }, null, 8, _hoisted_5)
                  ]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                    _createElementVNode("path", {
                      d: "M14.9016 10.6629L7.31006 18.2544C6.94393 18.6205 6.35033 18.6205 5.98424 18.2544L5.09881 17.369C4.7333 17.0035 4.7326 16.4111 5.09725 16.0447L11.1137 9.99996L5.09725 3.95523C4.7326 3.58887 4.7333 2.99648 5.09881 2.63098L5.98424 1.74555C6.35037 1.37941 6.94397 1.37941 7.31006 1.74555L14.9016 9.33707C15.2677 9.70316 15.2677 10.2968 14.9016 10.6629Z",
                      fill: $props.arrowColor || '#000000'
                    }, null, 8, _hoisted_7)
                  ]))
            ]))
          : _createCommentVNode("", true),
        (!$props.disableFolder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              ($setup.isOpen)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                    _createElementVNode("path", {
                      d: "M17.8967 10.1279L15.6334 14.0077C15.4573 14.3097 15.2051 14.5602 14.902 14.7343C14.5989 14.9084 14.2555 15 13.9059 15H1.40703C0.828188 15 0.467531 14.3721 0.759188 13.8721L3.02244 9.99225C3.19857 9.69031 3.45076 9.43981 3.75388 9.26571C4.05699 9.09161 4.40044 9 4.75 9H17.2489C17.8277 9 18.1884 9.62791 17.8967 10.1279ZM4.75 8H15V6.5C15 5.67156 14.3284 5 13.5 5H8.5L6.5 3H1.5C0.671562 3 0 3.67156 0 4.5V13.1889L2.15866 9.48837C2.69419 8.57031 3.68716 8 4.75 8Z",
                      fill: $props.folderColor || '#203972'
                    }, null, 8, _hoisted_10)
                  ]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                    _createElementVNode("g", _hoisted_12, [
                      _createElementVNode("path", {
                        d: "M14.5127 6.30005H7.7627L5.5127 4.05005H-0.112305C-1.0443 4.05005 -1.7998 4.80556 -1.7998 5.73755V15.8625C-1.7998 16.7945 -1.0443 17.55 -0.112305 17.55H14.5127C15.4447 17.55 16.2002 16.7945 16.2002 15.8625V7.98755C16.2002 7.05556 15.4447 6.30005 14.5127 6.30005Z",
                        fill: $props.folderColor || '#203972'
                      }, null, 8, _hoisted_13),
                      _createElementVNode("path", {
                        d: "M16.3125 4.5H9.5625L7.3125 2.25H1.6875C0.755508 2.25 0 3.00551 0 3.9375V14.0625C0 14.9945 0.755508 15.75 1.6875 15.75H16.3125C17.2445 15.75 18 14.9945 18 14.0625V6.1875C18 5.25551 17.2445 4.5 16.3125 4.5Z",
                        fill: $props.folderColor || '#203972'
                      }, null, 8, _hoisted_14)
                    ]),
                    _hoisted_15
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString($props.folderName), 1)
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", null, _toDisplayString($props.valor), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _withDirectives(_createElementVNode("div", {
        id: $setup.isOut ? 'slot_folder_open' : 'slot_folder_closed',
        class: "ps-4"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_19), [
        [_vShow, $setup.isOpen]
      ])
    ])
  ]))
}